export const EXPERIMENT_ID = 'tm-8381-guests-input-v1';

const VERSION_GUESTS_INPUT = 1;

let impressionSent = false;

/**
 * @todo TM-8381 keep the winning people field and drop the other one once the experiment is settled
 * @returns {?number} the allocated version, or null for visitors outside the experiment
 */
export const getGuestsInputVersion = () => window.getVersionFromCookieId?.(EXPERIMENT_ID) ?? null;

export const isGuestsInputVariant = () => getGuestsInputVersion() === VERSION_GUESTS_INPUT;

/**
 * Sent when the people field first renders, not on page load: on mobile the enquiry form only
 * opens on demand, and visitors who never see the field would only add noise to the experiment.
 */
export const trackGuestsInputImpression = (store) => {
  const version = getGuestsInputVersion();

  if (impressionSent || version === null) {
    return;
  }

  impressionSent = true;

  store.dispatch('trackGA4ExperimentImpression', {
    experimentId: EXPERIMENT_ID,
    version,
  });
};
